const ApiService = require("../../services/ApiService");

const state = () => ({
    shopTheLookVariations: []
});

const mutations = {
    setShopTheLookVariation(state, item)
    {
        state.shopTheLookVariations.push(item);
    }
};

const getters = {
    getShopTheLookVariation: (state) => (varId) => state.shopTheLookVariations.find(item => item.variation.id === varId)
};

const actions = {
    requestVariation({ state, commit }, variationId)
    {
        return new Promise((resolve, reject) =>
        {

            const cached = state.shopTheLookVariations.find(item => item.variation.id === variationId);

            if (cached)
            {
                resolve(cached);
            }

            ApiService.get(`/rest/io/variations/${variationId}/?shopTheLook=true`)
                .done(response =>
                {
                    // commit("setIsBasketLoading", false);
                    if (response.total <= 0)
                    {
                        reject("variation not found");
                    }

                    const newVariation = response.documents[0].data;

                    commit("setShopTheLookVariation", newVariation);
                    resolve(newVariation);
                })
                .fail(error =>
                {
                    // commit("setIsBasketLoading", false);
                    reject(error);
                });
        });
    }
};

export default
{
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
